import {
    Tooltip,
    TableCell
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./korrelationStyle";
import { round4Digits } from "../../../utils/utils";
import { useAppSelector } from "../../../app/hooks";
import { selectErgebnistyp } from "./korrelationFilterSlice";
import { CorrelationResultType } from "./korrelationTypes";

export default function ColorValues(
    props: { value: number, maxValue: number }
): ReactElement {

    const classes = {

        ...globalStyles(),
        ...useStyles()
    };

    const value = props.value;
    const maxValue = props.maxValue

    const ergebnistyp = useAppSelector(selectErgebnistyp);

    function setRainbow(color: string) {

        switch (color) {
            case "red": {
                const hslValue = (1 - value) * 50 + 50
                return "hsl(0, 100%," + hslValue + "%)";
            }
            case "blue": {
                const hslValue = (1 + value) * 50 + 50
                return "hsl(240, 100%," + hslValue + "%)";
            }
            default:
                return "hsl(240, 100%, 100%)";
        }
    }

    function setRainbowForAnzahl() {
        const hslValue = (((100 / maxValue) * value) - 100) * (-1);
        return "hsl(120, 60%," + hslValue + "%)";
    }


    function setRainbowForAnteil() {
        const hslValue = ((value - 100) * (-1));
        return "hsl(0, 100%," + hslValue + "%)";
    }

    if (value === null || value === undefined) {
        return (
            <Tooltip title="Keine Daten">
                <TableCell className={classes.tableCellKursivStyle}></TableCell>
            </Tooltip>
        )
    }
    else if (value <= 1 && value >= 0.0 && ergebnistyp == CorrelationResultType.single) {
        return (
            <Tooltip title={round4Digits(value)}>
                <TableCell className={classes.tableCellStyle} style={{ backgroundColor: setRainbow("red") }}></TableCell>
            </Tooltip>
        )
    } else if (value < 0.0 && ergebnistyp == CorrelationResultType.single) {
        return (
            <Tooltip title={round4Digits(value)}>
                <TableCell className={classes.tableCellStyle} style={{ backgroundColor: setRainbow("blue") }}></TableCell>
            </Tooltip>
        )
    } else if (ergebnistyp == CorrelationResultType.count) {
        return (
            <Tooltip title={round4Digits(value)}>
                <TableCell className={classes.tableCellStyle} style={{ backgroundColor: setRainbowForAnzahl() }}></TableCell>
            </Tooltip>
        )
    } else if (ergebnistyp == CorrelationResultType.percentage) {
        return (
            <Tooltip title={value*100 + "%"}>
                <TableCell className={classes.tableCellStyle} style={{ backgroundColor: setRainbowForAnteil() }}></TableCell>
            </Tooltip>
        )
    } else {
        return (
            <Tooltip title="Keine Daten">
                <TableCell className={classes.tableCellStyleGreyFrame}></TableCell>
            </Tooltip>
        )
    }
}